import React, { useState } from 'react';
import { Table, Button, Popover, InputNumber } from 'antd';
import { EllipsisOutlined, PercentageOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import { UpCircleOutlined, PieChartOutlined, ContainerOutlined, OrderedListOutlined } from '@ant-design/icons';
import { copy } from '../../utils/data.js';
import { withoutId } from '../../utils/data.js';
import { AccountProRataFunction, CompoundFunction, ParentFunction, PercentageSplitFunction } from '@lrea/ri-shared'
import PercentageSplitSubmenu from './PercentageSplitSubmenu.js';
import AccountBasedProRataSplitSubMenu from './AccountBasedProRataSplitSubMenu.js';
import CompoundSplitMenu from './CompoundSplitMenu.js';


function DivisionalProfitAndLossMenu(props) {

  const [menuVisible, setMenuVisible] = useState(true);
  const [percentageVisible, setPercentageVisible] = useState(false);
  const [accountProRataVisible, setAccountProRataVisible] = useState(false);
  const [compoundSplitVisible, setCompoundSplitVisible] = useState(false);
  const [width, setWidth] = useState(400);
  const [height, setHeight] = useState(250);
  const [open, setOpen] = useState(false);

  if (props.row_type === 'breakdown') {
    return null;
  }

  function onPercentageChange(column, value) {
    if (!value) {
      value = 0;
    }

    const newF = props.row.func.clone(props.row.func.id, props.row.func.target);
    newF.updated = true;    
    newF[column] = value;
    const newSplitState = newF.getSplit();       
    const newSplits = [...withoutId(props.model.splitState, newSplitState.id), newSplitState];
    props.setSplitsState(newSplits);
  }

  function renderPercentageSplit() {
    return <PercentageSplitSubmenu             
             row={props.row}             
             setMenuVisible={setMenuVisible}
             setPercentageVisible={setPercentageVisible}
             onPercentageChange={onPercentageChange}
             setOpen={setOpen}
           />
  }

  function renderAccountBasedProRata() {
    return <AccountBasedProRataSplitSubMenu
             model={props.model}
             row={props.row}
             setMenuVisible={setMenuVisible}
             setSplitsState={props.setSplitsState}
             setAccountProRataVisible={setAccountProRataVisible}
           />
  }

  function renderCompoundSplit() {
    return <CompoundSplitMenu
             model={props.model}
             row={props.row}
             setMenuVisible={setMenuVisible}
             setSplitsState={props.setSplitsState}
             setCompoundSplitVisible={setCompoundSplitVisible}
           />
  }

  function renderMenu() {    
    const defaultSelectedKeys = [props.row.operationType];
    const isReapBucket = props.row.row_type === 'reap-account';

    function handleClick(e) {
      if (props.readOnly) {
        return;
      }

      const splitType = e.key;

      if (splitType === 'parent') {                        
        const parent = props.model.accounts.find(a => a.id === props.row.accountId).reapAccountId;
        const f = new ParentFunction(props.row.func.id, props.row.func.pullId, props.row.func.target, parent, true)        
        const newSplitState = f.getSplit();
        const newSplits = [...withoutId(props.model.splitState, newSplitState.id), newSplitState];
        props.setSplitsState(newSplits);
      } else if (splitType === 'percentage') {        
        if (props.row.func.type !== 'percentage') {
          const f = new PercentageSplitFunction(props.row.func.id, props.row.func.pullId, props.row.func.target, true, 0, 0, 0);
          const newSplitState = f.getSplit();
          const newSplits = [...withoutId(props.model.splitState, newSplitState.id), newSplitState];
          props.setSplitsState(newSplits);
        }

        setMenuVisible(false);
        setPercentageVisible(true);
        setHeight(200);                
      } else if (splitType === 'account-pro-rata') {

        if (props.row.func.type !== 'account-pro-rata') {          
          const f = new AccountProRataFunction(props.row.func.id, props.row.func.pullId, props.row.func.target, true);
          const newSplitState = f.getSplit();
          const newSplits = [...withoutId(props.model.splitState, newSplitState.id), newSplitState];
          props.setSplitsState(newSplits);
        }

        setMenuVisible(false);
        setAccountProRataVisible(true);
        setWidth(800);
        setHeight(340);                
      } else if (splitType === 'compound-splits') {
        
        if (props.row.func.type !== 'compound') {
          const f = new CompoundFunction(props.row.func.id, props.row.func.pullId, props.row.func.target, [], true);
          const newSplitState = f.getSplit();
          const newSplits = [...withoutId(props.model.splitState, newSplitState.id), newSplitState];
          props.setSplitsState(newSplits);
        }

        setMenuVisible(false);
        setCompoundSplitVisible(true);
        setWidth(800);
        setHeight(400);        
      }
    }

    return (
      <Menu mode="vertical"
        defaultSelectedKeys={defaultSelectedKeys}
        selectable={!props.readOnly}>
        <Menu.Item key="parent" icon={<UpCircleOutlined />}
          disabled={isReapBucket}
          onClick={handleClick}>
          Inherit from Parent
        </Menu.Item>
        <Menu.Item key="percentage"
          icon={<PercentageOutlined />}
          onClick={handleClick}>
          Percentage Split
        </Menu.Item>        
        <Menu.Item key="account-pro-rata"
          icon={<ContainerOutlined />}
          onClick={handleClick}>
          Account Pro-Rata
        </Menu.Item>
        <Menu.Item key="compound-splits"
          disabled={isReapBucket}
          icon={<OrderedListOutlined />}
          onClick={handleClick}>
          Compound Splits
        </Menu.Item>
      </Menu>
    );
  }

  function renderPopup() {
    let childContent = null;

    if (menuVisible) {
      childContent = renderMenu();
    } else if (percentageVisible) {
      childContent = renderPercentageSplit();
    } else if (accountProRataVisible) {
      childContent = renderAccountBasedProRata();
    } else if (compoundSplitVisible) {
      childContent = renderCompoundSplit();
    }

    return (
      <div style={{height: height, width: width}}>
        {childContent}
      </div>
    );
  }

  function onOpenChange(openState) {
    setOpen(openState);
  }

  return (
    <Popover content={renderPopup()}
             trigger="click"
             open={open}
             onOpenChange={onOpenChange}>
      <Button shape="circle" size="small"
        icon={<EllipsisOutlined style={{ color: 'blue' }} />} />
    </Popover>
  );
};

export default DivisionalProfitAndLossMenu;
